angular
	.module 'App.Repository'
	.factory 'InventoryCountLineItemRepository',
	[
		'BaseRepository',
		(BaseRepository) ->
			class InventoryCountLineItemRepository extends BaseRepository
				@resource = '/inventory_count_line_items'
				@isRestricted = true

			return new InventoryCountLineItemRepository
	]
